import Vue from 'vue'
import VueSlider from 'vue-slider-component'
import '@core/scss/vue/libs/vue-slider.scss'

Vue.component(VueSlider)